import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useDataProvider, useRecordContext, useNotify, useRefresh } from "react-admin";
import { useLocation } from "react-router-dom";
import { Button } from "@mui/material";
const ActivateButton = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const location = useLocation();
  const cleanPath = location.pathname.replace(/^\//, "");
  if (!record) return null;

  const handleClick = async () => {
    await dataProvider
      .customRequest(`${cleanPath}/${record.id}/activate`, {}, "PUT")
      .then(() => {
        notify("Статуса е променен успешно!", { type: "success" });
        refresh();
      })
      .catch(error => {
        notify(`Грешка при промяна на статус: ${error.message}`, {
          type: "warning",
        });
      });
  };
  return (
    <Button
      onClick={handleClick}
      color="primary"
      size="small"
      startIcon={<CheckCircleIcon />}
    >
      Активирай
    </Button>
  );
};

export default ActivateButton;
